import gql from 'graphql-tag';

const sendHealthDeclarationsMutation = gql`
mutation sendHealthDeclarations($_id: String!, $email: String!){
    sendHealthDeclarations(_id: $_id, email: $email)
}
`;

export default sendHealthDeclarationsMutation;
